import * as types from "./types";
import Routes from "../../api/routes"; // API endpoint routes
import { get, getForSSR, getForWithoutHeader } from "../../api";
import { page_limit } from "utils";
const { BRAND_CATEGORY_BANNER_DETAILS, BRAND_CATEGORY_VEHICLE_DATA } = Routes;

/******************* 
@purpose :  get brand banner data
@Parameter : {}
@Author : INIC
******************/
export const getCategoryBannerData = (locationId, slug) => (dispatch) => {
  return getForWithoutHeader(
    `${BRAND_CATEGORY_BANNER_DETAILS}?location_id=${locationId}&category_slug=${slug}`,
    false
  ).then((res) => {
    if (res?.data) {
      dispatch(setCategoryBannerData(res?.data));
      return Promise.resolve(res.data);
    }
    return Promise.reject(res);
  });
};

/******************** 
@purpose : set category banner data
@Parameter : { data }
@Author : INIC
******************/
export const setCategoryBannerData = (data) => {
  return {
    type: types.SET_CATEGORY_BANNER_INFO,
    data,
  };
};

/******************* 
@purpose :  get brand banner data
@Parameter : {}
@Author : INIC
******************/
export const getCategoryVehicleData =
  (locationId, slug, authorizationToken = "") =>
  (dispatch) => {
    let fullUrl = "";

    if (authorizationToken) {
      fullUrl = getForSSR(
        `${BRAND_CATEGORY_VEHICLE_DATA}?location_id=${locationId}&category_slug=${slug}&page_limit=${page_limit}`,
        false,
        false,
        authorizationToken
      );
    } else {
      fullUrl = get(
        `${BRAND_CATEGORY_VEHICLE_DATA}?location_id=${locationId}&category_slug=${slug}&page_limit=${page_limit}`,
        false
      );
    }

    return fullUrl.then((res) => {
      if (res?.data) {
        return Promise.resolve(res);
      }
      return Promise.reject(res);
    });
  };
